var mentions_default = {
  "mentionPalette": "_8C7qE",
  "mention": "BnEhq",
  "mentionViewer": "BUp-K",
  "mentionSuggestionsEntry": "gYzhG",
  "mentionSuggestionsEntryFocused": "Ajrow",
  "mentionSuggestionsEntryText": "rs-C3",
  "mentionSuggestionsEntryAvatar": "fifsF",
  "mentionSuggestions": "e-vKh",
  "cursorDefault": "_58dx2",
  "cursorPointer": "Y83X7"
};
export {
  mentions_default as default
};
//# sourceMappingURL=mentions-scss.js.map
